import React, { useContext, useState } from 'react';
import { Popconfirm, InputNumber, Button, Divider, message } from 'antd';
import { EditOutlined } from '@ant-design/icons';

import IntlContext from '@/components/Intl/IntlContext';

import { orderChangePrice } from '@/api/goods';
import { renderIntlLabel } from '@/utils';
import { parseYuan2Currency } from '@/utils/number';

import styles from './BuyGoodsList.module.scss';

interface IBuyGoodsList {
  orderNo: string;
  list: Array<Object>;
  goodTotalInfo: { settleTotalActualPrice: number; actualPay: number; settleTotalCount: number };
  getOrderInfos: (orderNo: string) => void;
}
// 购物车
function BuyGoodsList($$: IBuyGoodsList) {
  const intlCtx = useContext(IntlContext);
  if (!$$.list || !$$.list.length) return null;

  // 改价弹框是否显示
  const [pop, setPop] = useState(false);

  // save loading
  const [saveLoading, setSaveLoading] = useState(false);

  // 改后的价格
  const [discountPrice, setDiscountPrice] = useState<any>('');

  const limitDecimals = (value) => {
    return Number(value)
      .toFixed(2)
      .replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
  };

  // 改价数字check
  const inputNumberCheck = (e: any) => {
    const val = Number(e.target.value);
    setDiscountPrice(val);
  };

  // 确认改价
  const editPrice = async () => {
    if (discountPrice === '') {
      message.warning(renderIntlLabel('goods_msg_please_input_sale_price'));
      return;
    }

    if (discountPrice > $$.goodTotalInfo.settleTotalActualPrice) {
      message.warning(renderIntlLabel('goods_msg_salePrice_cannot_higer_then_originalPrice'));
      return;
    }

    if (discountPrice < 0) {
      message.warning(renderIntlLabel('goods_msg_salePrice_cannot_lower_then_0'));
      return;
    }

    try {
      setSaveLoading(true);
      const { code } = await orderChangePrice({
        orderNo: $$.orderNo,
        totalActualPrice: discountPrice,
      });

      if (code === 0) {
        setPop(false);
        $$.getOrderInfos($$.orderNo);
      }
      setSaveLoading(false);
    } catch (error) {
      setSaveLoading(false);
      message.error(JSON.stringify(error));
    }
  };

  return (
    <div className={styles.buyGoodsList}>
      {$$.list.map((good: any) => {
        return (
          <div className={styles.item} key={good.id}>
            <div className={styles.name}>
              {good.spuName || '--'}({good.skuName})
            </div>
            <div className={styles.count}>X{good.goodsCount || 0}</div>
            <div className={styles.price}>
              {good.goodsTotalPrice !== good.actualTotalPrice && (
                <div className={styles.prePrice}>
                  <s>{parseYuan2Currency(good.goodsTotalPrice || 0)}</s>
                </div>
              )}
              <div className={styles.discountPrice}>
                {parseYuan2Currency(good.actualTotalPrice || 0)}
              </div>
            </div>
          </div>
        );
      })}
      <div className={styles.totalPrice}>
        <div className={styles.left}>
          {renderIntlLabel('goods_label_total_counts_of_goods', {
            settleTotalCount: $$.goodTotalInfo.settleTotalCount,
          })}
          <span className={styles.total}>
            {renderIntlLabel('goods_label_total_price')}：
            <span>{parseYuan2Currency($$.goodTotalInfo.settleTotalActualPrice || 0)}</span>{' '}
            {$$.goodTotalInfo.settleTotalActualPrice !== $$.goodTotalInfo.actualPay && (
              <>
                {renderIntlLabel('goods_label_sale_price')}：
                <span>{parseYuan2Currency($$.goodTotalInfo.actualPay || 0)}</span>
              </>
            )}
          </span>
        </div>
        <div className={styles.right}>
          {renderIntlLabel('goods_label_should_pay_finally')}：
          <span className={styles.actualPay}>
            {parseYuan2Currency($$.goodTotalInfo.actualPay || 0)}
            <Popconfirm
              title={
                <div className={styles.popContent}>
                  <InputNumber
                    controls={false}
                    prefix={intlCtx.TenantBaseConfig.CurrencySymbol}
                    value={discountPrice}
                    style={{ width: 250 }}
                    min={0}
                    precision={2}
                    formatter={limitDecimals}
                    parser={limitDecimals}
                    placeholder={renderIntlLabel('goods_msg_please_input_sale_price')}
                    onBlur={inputNumberCheck}
                    onPressEnter={inputNumberCheck}
                  />
                  <Button
                    type="link"
                    loading={saveLoading}
                    onClick={editPrice}
                    style={{ marginLeft: 12 }}
                  >
                    {renderIntlLabel('goods_action_save')}
                  </Button>
                  <Divider type="vertical" />
                  <Button type="link" onClick={() => setPop(false)}>
                    {renderIntlLabel('goods_action_cancel')}
                  </Button>
                </div>
              }
              disabled
              icon={null}
              placement="bottomRight"
              overlayClassName="editPopConfirm"
              visible={pop}
            >
              <Button
                style={{ backgroundColor: 'inherit', border: 'none' }}
                icon={<EditOutlined />}
                onClick={(e) => {
                  e.preventDefault();
                  setPop(!pop);
                }}
              />
            </Popconfirm>
          </span>
        </div>
      </div>
    </div>
  );
}

export default BuyGoodsList;
